import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../store/actions/index';
import Aux from '../../hoc/Aux';
import DocumentationFileTable from './DocumentationFileTable';
import ReadAllOfProductSystemDownloadButton from './ReadAllOfProductSystemDownloadButton.js'
import { useTranslation } from 'react-i18next';

const DocumentationFileTableList = (props) => {

  let documentationFiles = {};
  let documentationFileUserInfos = {};
  const productSystemId = props.productSystemId;

  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch( actions.fetchAllDocumentationFiles() ).then( dispatch( actions.fetchAllDocumentationFileUserInfos()) );
  }, []);

  const thisDocumentationFiles = useSelector(state => {
    return (productSystemId) => actions.getDocumentationFiles(state, productSystemId)
  });

  const thisDocumentationFileUserInfos = useSelector(state => {
    return (productSystemId) => actions.getDocumentationFileUserInfos(state, productSystemId)
  });

  const localizedDocumentationFiles = (files, loc) => {
    const filteredFiles = Object.values(files).filter( x => x.locale === loc )
    return filteredFiles
  }

  const tableLanguages = [
    {locale: "de", headline: "Deutsch"},
    {locale: "en", headline: "English"},
    {locale: "fr", headline: "Français"},
    {locale: "nl", headline: "Nederlands"},
    {locale: "no", headline: "Norsk"},

  ]
    documentationFiles = thisDocumentationFiles(productSystemId) || {};
    documentationFileUserInfos = thisDocumentationFileUserInfos(productSystemId) || {};

    return (
    <Aux>
      { ( documentationFiles !== null && documentationFiles !== undefined && documentationFiles !== {} && documentationFiles.length !== 0)?
  		<div className="tab-content" style={{backgroundColor: "white"}}>
        <div style={{float: "right", marginRight:"10px", paddingBottom: "20px"}}>
          { (documentationFileUserInfos.length > 0)? <ReadAllOfProductSystemDownloadButton productSystemId={productSystemId} /> : null }
        </div>

        { tableLanguages.map( (x) => <DocumentationFileTable
                      headline={ x['headline'] }
                      files={localizedDocumentationFiles(documentationFiles, x['locale'])}
                      fileInfos={documentationFileUserInfos}
                     /> )
        }
      </div> : <div>{ t('wizard.product_system_items.pane.document_downloads.no_documents_available') }</div>
    }

    </Aux>
)

}


export default DocumentationFileTableList;



// WEBPACK FOOTER //
// ./src/components/Documentations/DocumentationFileTableList.js